import { h } from 'preact';
import DirectionsIcon from 'utils/icon/icon-directions.svg';
import PhoneIcon from 'utils/icon/icon-phone.svg';
import MapPinIcon from 'utils/icon/icon-map-pin.svg';
import BookmarkIcon from 'utils/icon/icon-bookmark.svg';
import { useMemo } from 'preact/hooks';
import clsx from 'clsx';
import { useLocations } from './locations-context';

const StoreDetails = ({
  location,
  store,
  selectStore,
  stockData,
  listItem = false,
  hideMyStoreRow = false,
  ...props
}) => {
  const { userSavedStoreId, setUserSavedStoreId } = useLocations();
  const listClass = useMemo(() => {
    let className =
      'flex flex-col gap-x-36 gap-y-8 lc:md:flex-row lc:sm:gap-x-38 lc:md:gap-x-36 lg:flex-row flex-wrap lg:gap-y-8';

    if (userSavedStoreId !== location.storeId) {
      className += ' lg:justify-start';
    } else {
      className += ' lg:gap-32';
    }
    return className;
  }, [userSavedStoreId, store]);

  return (
    <div {...props}>
      <div className="display-4 mb-16 lg:mb-14">{location.name}</div>
      {!!userSavedStoreId &&
        !hideMyStoreRow &&
        (!listItem || location?.storeId === userSavedStoreId) && (
          <div className="flex gap-16 mb-16 items-center lg:mb-14">
            <div className="flex gap-8 p-4 bg-accent-2 ml:bg-grey-300 body-3 items-center">
              <BookmarkIcon />
              {window.TMW.Strings.storeLocator.myStore}
            </div>
            <button
              className="body-3-underline hover:no-underline"
              onClick={() => setUserSavedStoreId(null)}
            >
              {window.TMW.Strings.storeLocator.removeMyStore}
            </button>
          </div>
        )}
      <div className="body-3 mb-16 lg:mb-14">
        {!!location && location.availableFits && (
          <div className="ml:hidden onelaura-store-availablefits">
            {location.availableFits}
          </div>
        )}

        {!!location && (location.kmAway || location.kmAway === 0) && (
          <div className="lc:mt-14">
            {window.TMW.Strings.storeLocator.distanceAway.replace(
              '{{amount}}',
              location.kmAway,
            )}
          </div>
        )}
      </div>
      {!!stockData && (
        <div className="mb-16 lg:mb-14 flex items-center gap-4 ">
          <div
            className={clsx('w-8 h-8 ml:w-5 ml:h-5 rounded-full', {
              'bg-misc-green': stockData[location.storeId] > 1,
              'bg-misc-yellow': stockData[location.storeId] === 1,
              'bg-misc-sale ml:bg-error':
                !stockData[location.storeId] || stockData[location.storeId] < 1,
            })}
          ></div>
          <div className="body-3">
            {stockData[location.storeId] > 1
              ? window.TMW.Strings.storeLocator.inStock
              : stockData[location.storeId] === 1
              ? window.TMW.Strings.storeLocator.lowStock
              : window.TMW.Strings.storeLocator.outOfStock}
          </div>
        </div>
      )}
      <div className={listClass}>
        <a
          className="body-3-underline hover:no-underline flex gap-8 lg:gap-4 text-left"
          target="_blank"
          rel="noreferrer"
          href={`http://maps.google.com/?q=${location.address.formatted.join(
            ' ',
          )}`}
        >
          <div className="w-16 flex items-center justify-center">
            <DirectionsIcon className="w-14 h-auto" />
          </div>
          {window.TMW.Strings.storeLocator.directions}
        </a>
        <a
          className="body-3-underline hover:no-underline flex gap-8 lg:gap-4 text-left"
          href={`tel:${location.address.phone}`}
        >
          <div className="w-16 flex items-center justify-center">
            <PhoneIcon className="w-14 h-auto" />
          </div>
          {location.address.phone}
        </a>
        {userSavedStoreId !== location.storeId && (
          <button
            onClick={() => setUserSavedStoreId(location.storeId)}
            className="body-3-underline hover:no-underline flex gap-8 lg:gap-4 text-left"
          >
            <MapPinIcon className="w-16 h-auto" />
            {window.TMW.Strings.storeLocator.setMyStore}
          </button>
        )}
      </div>
    </div>
  );
};

//
export default StoreDetails;
